import {Injectable, OnDestroy} from '@angular/core';
import {Subscription, BehaviorSubject, timer} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {AjaxService} from 'AjaxService';

export interface ICountsViewModel {
  traegerRegCount?: number;
  antragBeCount?: number;
  antragUeberbelegungCount?: number;
  antragAnrechnungCount?: number;
  meldungenEoECount?: number;
  meldepflichtenCount?: number;
  meldungenJaehrlichCount?: number;
  hasNewSelbstauskunft?: number;
  clientServerPollTime: number;
  kind4JhrCount?: number;
  antragUmaCount?: number;
  antragVerweildauerCount?: number;
  antragUnterschreitungCount?: number;
}

@Injectable()
export class ServerPollService implements OnDestroy {
  private isInit: boolean = false;
  private timer_subscription: Subscription;
  private request_subscription: Subscription;
  private requestPending = false;
  private readonly defaultPollTime = 20000;
  private clientServerPollTime = this.defaultPollTime;

  private counts = new BehaviorSubject<ICountsViewModel>({} as ICountsViewModel);

  constructor(private ajaxService: AjaxService) {}

  public init(): BehaviorSubject<ICountsViewModel> {
    if (!this.isInit) {
      this.counts = new BehaviorSubject<ICountsViewModel>({} as ICountsViewModel);
      this.clientServerPollTime = this.defaultPollTime;
      this.isInit = true;
      this.startTimer();
    }

    return this.counts;
  }

  private timer_tick() {
    if (this.isInit && !this.requestPending) {
      this.requestPending = true;
      this.request_subscription = this.ajaxService.get<ICountsViewModel>('api/Poll/GetCounts').pipe(
        finalize(() => { this.requestPending = false; })
      ).subscribe({
        next: (response) => {
          this.counts.next(response);
          const pollTime = Number.isFinite(response.clientServerPollTime) && response.clientServerPollTime > 0
            ? response.clientServerPollTime : this.defaultPollTime;
          if (this.isInit && this.clientServerPollTime !== pollTime) {
            this.clientServerPollTime = pollTime;
            this.startTimer();
          }
        },
        error: (err) => {
          const status = err?.status ?? err?.httpErrorResponse?.status;
          if (status === 401 || status === 403) {
            this.Stop();
          }
          // Andere Fehler werden mit dem nächsten regulären Timerlauf erneut abgefragt.
        },
      });
    }
  }

  private startTimer() {
    this.timer_subscription?.unsubscribe();
    this.timer_subscription = timer(1000, this.clientServerPollTime).subscribe(() => this.timer_tick());
  }

  Stop() {
    this.isInit = false;

    this.timer_subscription?.unsubscribe();
    this.request_subscription?.unsubscribe();
    this.requestPending = false;

    if (this.counts) {
      this.counts.complete();
    }
  }

  ngOnDestroy(): void {
    this.Stop();
  }
}
